import { Network } from '@capacitor/network';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { SECOND } from '@sprytki-frontend-apps/common';
import { APP_CONFIG } from 'api/interfaces/config';
import { refreshTokenData } from 'api/services/apiClient';
import { storageKeys } from 'shared/constants';

let connection: HubConnection | null = null;

export const initConnection = (hubName: string) => {
	connection = new HubConnectionBuilder()
		.withUrl(`${APP_CONFIG?.hubsURL}/${hubName}`, {
			accessTokenFactory: getAccessToken,
			withCredentials: false,
		})
		.configureLogging(LogLevel.Information)
		.withAutomaticReconnect({
			nextRetryDelayInMilliseconds: (retryContext) => {
				const { previousRetryCount } = retryContext;

				if (previousRetryCount > 100) return null;

				if (previousRetryCount === 0) return 0;
				if (previousRetryCount < 60) return 1 * SECOND;
				return 5 * SECOND;
			},
		})
		.build();

	connection.onreconnecting(refreshTokenAndReconnect);

	startConnection();

	return connection;
};

const startConnection = () => {
	if (!connection) return;

	connection.start().catch((err) => {
		const unauthorizedError = err?.message?.includes('401');

		if (unauthorizedError) {
			refreshTokenAndReconnect();
			return;
		}

		console.error('SignalR connection error: ', err);
	});
};

export const reconnect = async () => {
	if (!connection) return;

	await connection.stop();

	startConnection();
};

const refreshTokenAndReconnect = async () => {
		const status = await Network.getStatus();

		if (status.connected) {
		refreshTokenData(null, true).then(reconnect);
	}
};

export const getConnection = () => {
	if (!connection) {
		throw new Error('Connection not initialized. Call initConnection first.');
	}
	return connection;
};

const getAccessToken = () =>
	sessionStorage.getItem(storageKeys.ACCESS_TOKEN) || localStorage.getItem(storageKeys.ACCESS_TOKEN) || '';
